import Reflux from 'reflux';
import http from '../../services/fetch';
import RetIslr from '../../Models/RetIslr';
import RetIslrActions from '../RetIslrActions';
import Proveedor from '../../Models/Proveedor';
import Factura from '../../Models/Factura';
import ErrorHandlerStore from './ErrorHandlerStore';
import AlertActions from '../AlertActions';
import AuthActions from '../AuthActions';
import moment from 'moment';
import _ from 'underscore';

var RetIvaStore = Reflux.createStore({
    init: function() {
        this.listenToMany(RetIslrActions);
        this.take = 8;

        this.retIslrs = [];
    },

    postRetIslr: function(retIslr, sendmail) {
        retIslr.proveedor_id = retIslr.proveedor.id;

        retIslr.fecha_retencion = moment(retIslr.fecha_retencion).format('YYYY-MM-DD');
        retIslr.fecha_documento = moment(retIslr.fecha_documento).format('YYYY-MM-DD');
        let send = sendmail ? '?sendmail=true' : '?sendmail=false';
        http.post('retislr'+send, retIslr,  this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.retIslr = new RetIslr(json.retislr);
            AuthActions.checkLogin();
            this.trigger('postedRetIslr', this.retIslr, json.sentByMail);
        });

    },

    /**
     * GET request to obtain all Retivas for the user
     *
     */
    getRetIslrs: function(count) {
        http.get('retislrs', this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.retIslrs = json.retislrs.map((retIslr) => {
                return new RetIslr(retIslr);
            });

            this.trigger('getRetIslrs', this.retIslrs, json.count);
        });
        
    },

    /**
     * GET request to obtain all Retivas for the user
     *
     */
    getRetIslr: function(id) {
        
        http.get('retislr/'+id, this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.retIslr = new RetIslr(json);
            this.trigger('getRetIslr', this.retIslr);
        });
        
    },

    /**
     * GET request to obtain all Retivas for the user
     *
     */
    putRetIslr: function(retIslr, sendmail) {
        let send = sendmail ? '?sendmail=true' : '';
        retIslr.fecha_retencion = moment(retIslr.fecha_retencion).format('YYYY-MM-DD');
        retIslr.fecha_documento = moment(retIslr.fecha_documento).format('YYYY-MM-DD');
        http.put('retislr'+send, retIslr, this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.retIslr = new RetIslr(json);
            this.trigger('putRetIslr', this.retIslr);
        });
    },

    /**
     * Delete request to destroy a retiva
     *
     */
    deleteRetIslr: function(retIslr) {
        http.delete('retislr/'+retIslr.id, this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            RetIslrActions.getRetIslrs();
            this.trigger('deleteRetIslr', retIslr);
        });
    },

    sendMail: function(id) {

    },

    /**
     * Download RetivaPDF
     *
     */
    download: function(id) {
        http.download('retislr/'+id+'/pdf');
    },

    getProximaRetencion: function() {

    },

    /**
     * Performs a get request to obtain retivas from the specified range
     *
     * @param {string} since The since date
     * @param {string} until The until date
     *
     */
    getReport: function(since, until, download) {
        since = 'since='+since;
        until = '&until='+until;
        let token = '&access_token='+this._getToken();

        if (download) {
            http.download('retivas/txt?'+since+until+token);
            return 0;
        }

        http.get('retivas/report?'+since+until, this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            let retivas = json.map((retiva) => {

                //Verify if this retiva has a duplicate in the array
                retiva.duplicate = this._findDuplicates(json, retiva);

                return new Retiva(retiva);
            });

            this.trigger('getReport', retivas);
        });
    },

    /**
     * Handles search according to query received from TextField
     *
     * @param e Event: TextField in which the query is being typed
     */
    apiFilter: function(q) {
        http.get('retislrs?query='+q, this._getToken())
        .then(ErrorHandlerStore.checkForErrors)
        .then((json) => {
            this.retislrs = json.retislrs.map((retislr) => new RetIslr(retislr));

            this.trigger('getRetIslrs', this.retislrs, json.count);
        });
    },

    /**
     * Handles search according to query received from TextField
     *
     * @param e Event: TextField in which the query is being typed
     */
    filter: function(e) {
        let query = e.target.value,
        list = this.retivas,
        reg = new RegExp(query, 'gi');

        list = list.filter(
            (item, index) => item.primaryText.match(reg) || item.secondaryText.match(reg)
        );


        this.trigger('filter', list);
    },

    _findDuplicates: function(retivas, retiva) {
        let duplicates = _.where(retivas, {number:retiva.number});
        if (duplicates.length > 1)
            return true;
        else
            return false;
    },

    _getToken: function() {
        return localStorage.getItem('access_token');
    },

    _formatPostBody: function(retiva) {
        const facturas = retiva.facturas.map((factura) => {
            return {
                fecha: factura.dateAPI,
                numero_documento: factura.numeroDoc,
                tipo: factura.tipo,
                documento_afectado: factura.documentoAfectado,
                numero_control: factura.noControl,
                total_compras: factura.totalCompra,
                sin_credito: factura.sinCredito,
                base_imponible: factura.baseImponible,
                iva: factura.iva,
                iva_offset: parseInt(factura.iva_offset),
                porcentaje_retencion: factura.percentage
            };
        });

        const body = {
            id: retiva.id,
            proveedor_id: retiva.proveedor.id,
            date: retiva.dateAPI,
            number: retiva.number,
            detalle: facturas,
        };

        return body;
    }
});

export default RetIvaStore;



/** WEBPACK FOOTER **
 ** ./app-react/reflux/stores/RetIslrStore.js
 **/